<template>
    <div class="d-flex">
        <div class="">
            <v-select :options="timeOptions" v-model="selectedTimeOption" @input="rangeDropdownChanged"></v-select>
        </div>
        <div class="d-flex flex-row align-items-center ml-2" v-if="selectedTimeOption.value == 'custom'">
                <label class="mr-2">From</label>
                <vue-datepicker
                class="mr-0"
                v-model="pickerDateFrom"
                @input="customDateChanged"
                :monday-first="false"
                wrapper-class="date-input"
                format="yyyy-MM-dd"
                :required="false">

                </vue-datepicker>
                <label class="ml-2 mr-2">To</label>
                <vue-datepicker
                class="mr-0"
                v-model="pickerDateTo"
                @input="customDateChanged"
                :monday-first="false"
                wrapper-class="date-input dateToCalendar"
                format="yyyy-MM-dd"
                :required="false">
                </vue-datepicker>
        </div>
    </div>
</template>

<script>
import extendedVSelect from '@/extends/vue-select'
import VueDatepicker from 'vuejs-datepicker'

export default {
    data: function() {
        return {
            timeOptions:[
                {
                    label:'Today',
                    value:'today'
                },
                {
                    label:'This Week',
                    value:'week'
                },
                {
                    label:'This Month',
                    value:'month'
                },
                {
                    label:'Custom',
                    value:'custom'
                }
            ],
            selectedTimeOption:{
                label:'Today',
                value:'today'
            },
            thisMonth: '',
            dateFrom: null, // this needs to be set on created
            dateTo: null, // this needs to be set on created
            dashboardData: null
        }
    },
    props: {
        value:{
            type: Array
        }
    },
    created: function() {
        this.dateFrom = this.value[0]
        this.dateTo = this.value[1]
    },
    computed: {
        pickerDateFrom:{
            get: function(){
                return moment(this.dateFrom).format('YYYY-MM-DD')
            },
            set: function(value){
                this.dateFrom = moment(value)
            }
        },
        pickerDateTo:{
            get: function(){
                return moment(this.dateTo).format('YYYY-MM-DD')
            },
            set: function(value){
                this.dateTo = moment(value)
            }
        },
    },
    methods: {
        rangeDropdownChanged: function(e){
            if(e == null){
                this.selectedTimeOption = {
                    label:'Today',
                    value:'today'
                }
            }

            switch (e.value) {
                case 'custom':
                    break;

                case 'today':
                    this.dateFrom = moment().startOf('day')
                    this.dateTo = moment().endOf('day')
                    break;

                case 'week':
                    this.dateFrom = moment().startOf('week')
                    this.dateTo = moment().endOf('week')
                    break;

                case 'month':
                    this.dateFrom = moment().startOf('month')
                    this.dateTo = moment().endOf('month')
                    break;

                default:
                    this.dateFrom = moment().startOf('day').format('YYYY-MM-DD')
                    this.dateTo = moment().endOf('day').format('YYYY-MM-DD')
            }

            this.outputInfo()
        },
        customDateChanged: function(){
            this.outputInfo()
        },
        outputInfo: function() {
            this.$emit('input',[
                this.dateFrom,
                this.dateTo
            ])
        }
    },
    components: {
        vSelect: extendedVSelect,
        VueDatepicker
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// rangePicker.vue?16d9fa1c